var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{attrs:{"id":"map","data-test":"world-map-wrapper"}}),(!_vm.selectedContinent && _vm.totalResults > 0)?_c('ContinentSummary',{on:{"locationhover":_vm.mouseOverLocationSummary}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }